import React from 'react';
import { Layout as AntLayout, ConfigProvider } from 'antd';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { TutorProgramProvider } from '../../../contexts/TutorProgramContext';
import { ThemeProvider, useTheme } from '../../../contexts/ThemeContext';
import { getThemeConfig } from '../../../theme/themeConfig';
import '../../../styles/admin-theme.css';

const { Content } = AntLayout;

const TutorLayoutContent: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { isDark } = useTheme();
  const themeConfig = getThemeConfig(isDark);
  const [collapsed, setCollapsed] = React.useState(false);
  const [mobileDrawerOpen, setMobileDrawerOpen] = React.useState(false);

  return (
    <ConfigProvider theme={themeConfig}>
      <AntLayout style={{ minHeight: '100vh' }}>
        <Sidebar
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          mobileDrawerOpen={mobileDrawerOpen}
          setMobileDrawerOpen={setMobileDrawerOpen}
        />
        <AntLayout style={{ minWidth: 0 }}>
          <Header
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            onOpenMobileDrawer={() => setMobileDrawerOpen(true)}
          />
          <Content
            style={{
              minHeight: 280,
              backgroundColor: 'hsl(var(--background))',
              color: 'hsl(var(--foreground))',
              overflowX: 'hidden',
              minWidth: 0,
            }}
          >
            {children || <Outlet />}
          </Content>
          <Footer />
        </AntLayout>
      </AntLayout>
    </ConfigProvider>
  );
};

export const TutorLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <ThemeProvider>
      <TutorProgramProvider>
        <TutorLayoutContent>{children}</TutorLayoutContent>
      </TutorProgramProvider>
    </ThemeProvider>
  );
};

export default TutorLayout;
